import React from "react";
import styled from "styled-components";

const Msg = styled.div`
    padding: 12px 16px;
    text-align: center;
    font-family: "Inter", system-ui, sans-serif;
`;

const MsgText = styled.div`
    font-size: 0.85rem;
    color: #64748b;
    margin-bottom: 8px;
`;

const MsgBtn = styled.button`
    background: #6366f1;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 6px 14px;
    font-size: 0.8rem;
    font-weight: 600;
    font-family: "Inter", system-ui, sans-serif;
    cursor: pointer;
    &:hover { background: #4f46e5; }
`;

export const NoGAConnected = (classes, actionCallback) => () => (
    <Msg>
        <MsgText>No Google Analytics accounts connected.</MsgText>
        <MsgBtn onClick={actionCallback}>Add account</MsgBtn>
    </Msg>
);

export const NoViewsAvailable = (classes, views, setFilters) => () => (
    <Msg>
        <MsgText>
            {views.length > 0
                ? `No view matches the website URL. (${views.length} hidden)`
                : "No views available for this account."}
        </MsgText>
        {views.length > 0 && (
            <MsgBtn onClick={() => setFilters({ workspaceUrlActive: false })}>Clear filters</MsgBtn>
        )}
    </Msg>
);
